module.exports = __webpack_public_path__ + "static/media/kerstman-door-het-ijs-1.85a7c1a1.jpeg";